import * as React from "react";
import CssBaseline from "@mui/material/CssBaseline";
import Grid from "@mui/material/Grid";
import GlobalStyles from "@mui/material/GlobalStyles";
import Container from "@mui/material/Container";

function Trial({ children }) {
  return (
    <React.Fragment>
      <GlobalStyles
        styles={{ ul: { margin: 0, padding: 0, listStyle: "none" } }}
      />
      <CssBaseline />
      <Container maxWidth="lg">
        <Grid container direction="column" alignItems="center" sx={{
          pt: 8,
          pb: 6
        }}>
          <h2 className="page-header">
            Free Evaluation Licence
          </h2>
          <p className="subtext text-center">
            If you'd like to try Arcmutate, we'd be happy to provide a <strong>free</strong> 30 day evalutation licence.</p>
          <p className="subtext text-center"> We just need your email address and the root package of your codebase. Once provided,
            you'll be taken to stripe.com where you'll be asked to fill in some additional details. You will <strong>not</strong> be asked for a credit
            card number.
          </p>

          {children}

          <p className="subtext text-center">Alternatively <a href="mailto:support@arcmutate.com">email us</a> to discuss your requirements.</p>
        </Grid>
      </Container>
    </React.Fragment>
  );
}

export default Trial;
